module.exports = __webpack_public_path__ + "static/img/bestImg1.39ee70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/bestImg1.png
// module id = FE48
// module chunks = 1